// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "../EnumHelperFuncs";
export var ActiveStatus = ( /* @__PURE__ */createEnumStyle({
    NONE: 0 /* eActiveStatus.NONE */,
    PENDING: 3 /* eActiveStatus.PENDING */,
    INACTIVE: 1 /* eActiveStatus.INACTIVE */,
    ACTIVE: 2 /* eActiveStatus.ACTIVE */
}));
//# sourceMappingURL=InitActiveStatusEnum.js.map